import _ from 'lodash';
import React, { useMemo } from 'react';
import { MemberFilter } from '~/components';
import ContactTagFilter from './ContactTagFilter';

function ContactFiltersBar({ filters, sticky, onChange }) {
  const visible = useMemo(() => {
    const isVisible = (key) => sticky?.includes(key) || !_.isEmpty(filters[key]);

    return {
      contactOwners: isVisible('contactOwners'),
      contactTags: isVisible('contactTags'),
    };
  }, [filters, sticky]);

  return (
    <>
      {visible.contactOwners && (
        <MemberFilter
          name="contactOwners"
          placeholder="Contact Owner"
          value={filters.contactOwners}
          onChange={({ target: { value } }) => onChange({ contactOwners: value })}
        />
      )}
      {visible.contactTags && (
        <ContactTagFilter
          name="contactTags"
          placeholder="Contact Tags"
          value={filters.contactTags}
          onChange={({ target: { value } }) => onChange({ contactTags: value })}
        />
      )}
    </>
  );
}

export default ContactFiltersBar;
